<template>
	<modal
		:modal-id="modalId"
		:title="modalTitle"
		:preloader="preloader"
		@submit="submit"
		@close-modal="closeModal"
	>
		<template slot="body">
			<app-overlay-loader v-if="preloader" />
			<form
				class="mb-0"
				:class="{ 'loading-opacity': preloader }"
				ref="form"
				:data-url="
					selectedUrl
						? `transaction/course-group/${inputs.id}`
						: `transaction/course-group`
				"
			>
				<!-- Center ID -->
				<div class="form-group row align-items-center">
					<label for="inputs_center_id" class="col-sm-3 mb-0">
						Center
					</label>
					<app-input
						id="inputs_center_id"
						class="col-sm-9"
						type="search-select"
						:list="centerIdLists"
						v-model="inputs.center_id"
						:placeholder="'Center'"
						:required="true"
					/>
				</div>

				<!-- Class Group -->
				<div class="form-group row align-items-center">
					<label for="inputs_course_group_name" class="col-sm-3 mb-0">
						Class Group
					</label>
					<app-input
						id="inputs_course_group_name"
						class="col-sm-9"
						type="text"
						v-model="inputs.course_group_name"
						:placeholder="'Class Group'"
						:required="true"
					/>
				</div>

				<!-- Teacher ID -->
				<div class="form-group row align-items-center">
					<label for="inputs_teach_id" class="col-sm-3 mb-0">
						Main Teacher
					</label>
					<app-input
						id="inputs_teach_id"
						class="col-sm-9"
						type="search-select"
						:list="teachIdLists"
						v-model="inputs.teach_id"
						:placeholder="'Main Teacher'"
						:required="true"
					/>
				</div>

				<!-- Teacher Side ID -->
				<div class="form-group row align-items-center">
					<label for="inputs_teach_side_id" class="col-sm-3 mb-0">
						CO Teacher
					</label>
					<app-input
						id="inputs_teach_side_id"
						class="col-sm-9"
						type="search-select"
						:list="teachSideIdLists"
						v-model="inputs.teach_side_id"
						:placeholder="'CO Teacher'"
						:required="true"
					/>
				</div>

				<!-- Teach Trainer ID -->
				<div class="form-group row align-items-center">
					<label for="inputs_teach_trainer_id" class="col-sm-3 mb-0">
						Teacher Trainer
					</label>
					<app-input
						id="inputs_teach_trainer_id"
						class="col-sm-9"
						type="search-select"
						:list="teachTrainerIdLists"
						v-model="inputs.teach_trainer_id"
						:placeholder="'Teacher Trainer'"
						:required="true"
					/>
				</div>

				<!-- Teacher Assistant ID -->
				<div class="form-group row align-items-center">
					<label
						for="inputs_teach_assistant_id"
						class="col-sm-3 mb-0"
					>
						Teacher Assistant
					</label>
					<app-input
						id="inputs_teach_assistant_id"
						class="col-sm-9"
						type="search-select"
						:list="teacherAssistantIdLists"
						v-model="inputs.teach_assistant_id"
						:placeholder="'Teacher Assistant'"
						:required="true"
					/>
				</div>

				<!-- Student Care ID #1 -->
				<!-- <div class="form-group row align-items-center">
					<label for="inputs_student_care_id" class="col-sm-3 mb-0">
						Student Care #1
					</label>
					<app-input
						id="inputs_student_care_id"
						class="col-sm-9"
						type="search-select"
						:list="studentCareId1Lists"
						v-model="inputs.student_care_id"
						:placeholder="'Student Care #1'"
						:required="true"
					/>
				</div> -->

				<!-- Student Care ID #2 -->
				<!-- <div class="form-group row align-items-center">
					<label
						for="inputs_student_care_side_id"
						class="col-sm-3 mb-0"
					>
						Student Care #2
					</label>
					<app-input
						id="inputs_student_care_side_id"
						class="col-sm-9"
						type="search-select"
						:list="studentCareId2Lists"
						v-model="inputs.student_care_side_id"
						:placeholder="'Student Care #2'"
						:required="true"
					/>
				</div> -->

				<div class="form-group row align-items-center">
					<label for="inputs_is_active" class="col-sm-3 mb-0">
						&nbsp;
					</label>
					<div class="col-sm-8">
						<app-input
							id="inputs_is_active"
							:list-value-field="$t('is_active')"
							type="single-checkbox"
							v-model="inputs.is_active"
						/>
					</div>
				</div>

				<!-- Note -->
				<div class="form-group row align-items-center">
					<label for="inputs_note" class="col-sm-3 mb-0">
						Note
					</label>
					<app-input
						id="inputs_note"
						class="col-sm-9"
						type="textarea"
						v-model="inputs.note"
						:placeholder="'Note'"
						:required="true"
					/>
				</div>
			</form>
		</template>
	</modal>
</template>

<script>
import { FormMixin } from "../../../../../core/mixins/form/FormMixin.js";
import { ModalMixin } from "../../../../Mixins/ModalMixin";

export default {
	name: "ModalForm",
	mixins: [FormMixin, ModalMixin],
	props: {
		tableId: String,
		formId: String,
		value: {
			type: Object,
			default: () => {
				return {
					id: undefined,
					course_type_name: "",
					is_active: "",
				};
			},
		},
	},
	data() {
		return {
			preloader: false,
			inputs: {
				center_id: "",
				course_group_name: "",
				teach_id: "",
				teach_side_id: "",
				teach_trainer_id: "",
				is_active: "",
			},
			centerIdLists: [],
			teachIdLists: [],
			teachSideIdLists: [],
			teachTrainerIdLists: [],
			teacherAssistantIdLists: [],
			studentCareId1Lists: [],
			studentCareId2Lists: [],
			// statusLists: [
			//     {id: '', value: "Choose One",},
			//     {id: 'active', value: "Active",},
			//     {id: 'inactive', value: "Inactive",},
			//     {id: 'invited', value: "Invite",},
			// ],
			// genderLists: [
			//     {id: 'male', value: "Male"},
			//     {id: 'female', value: "Female"},
			//     {id: 'other', value: "Other"},
			// ],
			modalId: this.formId,
			modalTitle: this.$t("add"),
		};
	},
	created() {
		if (this.selectedUrl) {
			this.modalTitle = this.$t("edit");
			this.preloader = true;
		}

		this.fetchData();
	},
	methods: {
		async fetchData() {
			try {
				if (this.selectedUrl) {
					this.modalTitle = this.$t("edit");
					this.preloader = true;
				}

				let [centerResponse, teacherResponse] = await Promise.all([
					axios.get("/master/center?per_page=1000"),
					axios.get("/user-list?per_page=1000"),
				]);

				centerResponse.data.data.map((item) => {
					this.centerIdLists.push({
						id: item.id,
						value: item.name,
					});
				});

				teacherResponse.data.data.map((item) => {
					this.teachIdLists.push({
						id: item.id,
						value: item.full_name,
					});

					this.teachSideIdLists.push({
						id: item.id,
						value: item.full_name,
					});

					this.teachTrainerIdLists.push({
						id: item.id,
						value: item.full_name,
					});

					this.teacherAssistantIdLists.push({
						id: item.id,
						value: item.full_name,
					});

					this.studentCareId1Lists.push({
						id: item.id,
						value: item.full_name,
					});

					this.studentCareId2Lists.push({
						id: item.id,
						value: item.full_name,
					});
				});
			} catch (error) {
				console.error("Error fetching data:", error);
			}
		},
		submit() {
			this.inputs.is_active = this.inputs.is_active ? 1 : 0;
			this.save(this.inputs);
		},
		afterSuccess(response) {
			this.$toastr.s(response.data.message);
			this.$hub.$emit("reload-" + this.tableId);
		},

		afterSuccessFromGetEditData(response) {
			this.inputs = response.data;
			this.inputs.teach_id = response.data.teach_id.id;
			this.inputs.teach_side_id = response.data.teach_side_id.id;
			this.inputs.teach_trainer_id = response.data.teach_trainer_id.id;
			this.inputs.teach_assistant_id = response.data.teach_assistant_id ? response.data.teach_assistant_id.id : '';
			this.preloader = false;
		},
	},
};
</script>
